import { render } from "./MiInfiniteScroll.vue?vue&type=template&id=292891aa"
import script from "./MiInfiniteScroll.vue?vue&type=script&lang=js"
export * from "./MiInfiniteScroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInfiniteScroll});
